/**
 * MagneticButton — CSS-only hover lift.
 *
 * Formerly a JS magnetic-pull effect driven by mousemove + springs.
 * Replaced with a pure CSS transition (see .btn-lift in index.css) so
 * there are zero mouse listeners anywhere in the app.
 */
export default function MagneticButton({
  as: Tag = "button",
  className = "",
  children,
  ...rest
}) {
  return (
    <Tag className={`btn-lift ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
